import { fetchJsonWithDefaultHeaders } from 'common/http';

export enum ScanStatus {
  /* Returned from the API
  -------------------------------------------------- */
  // The scan passed
  Ok = 'ok',

  // The scan failed
  Bad = 'bad',

  // The scan was skipped because the file is too large to scan
  TooLarge = 'toolarge',

  // Unsure
  Unscanned = 'unscanned',

  // Unsure - Seems to be DSMAPI only
  Empty = 'empty',

  /* Used only by the Frontend
  -------------------------------------------------- */
  // Used by the frontend as a placeholder for when scan data can't be retrieved */
  Unknown = 'unknown',

  // Used by the frontend as a placeholder while results are being fetched */
  Loading = 'loading',
}

export interface ScanResult {
  state: ScanStatus;
  scannedAt: string | null; // representing a date
}

export interface AttachmentScanResult {
  [key: string]: ScanResult;
}

export interface AttachmentScanResults {
  files: AttachmentScanResult;
}

/**
 * Makes an API request for the security scan results of all attachments for an asset
 * @param viewId 4x4 of the asset the attachment is on
 * @returns Promise object which should resolve to a ScanResult type object
 */
export const fetchAttachmentJudgements = (viewId: string): Promise<AttachmentScanResults> =>
  fetchJsonWithDefaultHeaders(`/api/views/${viewId}/files?method=attachmentJudgements`);

/**
 * Makes an API request for the security scan results of a single attachment file
 * @param viewId 4x4 of the asset the attachment is on
 * @param fileId 4x4 or blob string of the attachment
 * @returns Promise object which should resolve to a ScanResult type object
 */
export const fetchFileJudgement = (viewId: string, fileId: string): Promise<ScanResult> =>
  fetchJsonWithDefaultHeaders(`/api/views/${viewId}/files/${fileId}?method=judgement`);
